/** Пауза «скан закончен» без Enter. 180мс резало медленные BT-сканеры пополам. */
export const SCAN_IDLE_MS = 400;

const NON_TEXT_INPUT_TYPES = new Set([
  'button',
  'submit',
  'reset',
  'checkbox',
  'radio',
  'file',
  'image',
  'hidden',
  'color',
  'range',
]);

/**
 * HID-сканер ≠ ручной ввод: часто шлёт AIM ("]E0"/"]C1"), GS/FNC1, CR и GTIN-14 с нулём.
 * Без очистки бэкенд ищет «грязную» строку и отвечает «не найден в очереди проклейки».
 */
export function normalizeHidScanCode(raw) {
  let code = String(raw ?? '');
  code = code.replace(/[\u0000-\u001f\u007f-\u009f]/g, '');
  code = code.trim();
  // AIM Symbology Identifier: ]E0, ]C1, ]d2 …
  code = code.replace(/^\][A-Za-z][A-Za-z0-9]/, '');
  // Одиночный ] перед цифрами (урезанный FNC1/AIM)
  if (/^\]\d/.test(code)) code = code.slice(1);
  code = code.trim();
  // GTIN-14 с ведущим 0 → EAN-13 (карточки у нас хранят 13 цифр)
  if (/^0\d{13}$/.test(code)) code = code.slice(1);
  return code;
}

export function isTypingTarget(node) {
  if (!node) return false;
  const el = node.nodeType == null || node.nodeType === 1 ? node : node.parentElement;
  if (!el) return false;
  if (el.getAttribute?.('data-tsd-scan') === '1' || el.closest?.('[data-tsd-scan="1"]')) return false;
  if (el.isContentEditable || el.getAttribute?.('contenteditable') === 'true') return true;
  const tag = String(el.tagName || '').toUpperCase();
  if (tag === 'TEXTAREA') return !el.disabled && !el.readOnly;
  if (tag !== 'INPUT') return false;
  if (el.disabled || el.readOnly) return false;
  const type = String(el.type || 'text').toLowerCase();
  return !NON_TEXT_INPUT_TYPES.has(type);
}

export function isOwnScanField(node) {
  if (!node) return false;
  const el = node.nodeType == null || node.nodeType === 1 ? node : node.parentElement;
  return el?.getAttribute?.('data-tsd-scan') === '1' || Boolean(el?.closest?.('[data-tsd-scan="1"]'));
}

export function hidScanKeyAction(event, options = {}) {
  if (options.capture === false || options.paused || options.ownField) return { action: 'ignore' };
  if (event?.isComposing || event?.keyCode === 229) return { action: 'ignore' };
  if (event?.ctrlKey || event?.metaKey || event?.altKey) return { action: 'ignore' };
  if (event?.repeat) return { action: 'ignore' };

  const key = event?.key;
  const hasBuffer = Boolean(options.hasBuffer);
  if (key === 'Enter' || event?.keyCode === 13) {
    if (options.typing || options.ownField) return { action: 'ignore' };
    if (!hasBuffer) return { action: 'ignore', preventDefault: true };
    return { action: 'flush', preventDefault: true };
  }
  const char = scanChar(event);
  if (!char) return { action: 'ignore' };
  if (options.typing) return { action: 'ignore' };
  if (char === ' ' && !hasBuffer) return { action: 'ignore' };
  return { action: 'append', char, preventDefault: true };
}

function scanChar(event) {
  const key = event?.key;
  if (typeof key === 'string' && key.length === 1) return key;
  const code = Number(event?.keyCode || event?.which || 0);
  if (code >= 32 && code <= 126) return String.fromCharCode(code);
  return '';
}
